// extracted by mini-css-extract-plugin
module.exports = {"image-nav-arrow":"ImageNavigationArrow_image-nav-arrow__tV4rI"};